export default __webpack_public_path__ + "static/media/TheDodo.2e0d7964.svg";